import { createSlice } from '@reduxjs/toolkit';

const SettlementsSlice = createSlice({
  name: 'SettlementsSlice',
  initialState: {
    isLoading: false,
    getSettlementsData: [],
    isError: null,
    isPDFDownload: false,
    isEmailSending: false,
    isGenerating: false,
  },
  reducers: {
    ////////// get Settlements data /////////
    requestGetSettlements: (state) => {
      return { ...state, isLoading: true };
    },
    responseGetSettlements: (state, action) => {
      return {
        ...state,
        isLoading: false,
        getSettlementsData: action.payload,
      };
    },
    failureGetSettlements: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    /////// Download Settlements PDF (Merchant Invoice) ////////
    requestDownloadSettlementsPDF: (state) => {
      return { ...state, isPDFDownload: true };
    },
    responseDownloadSettlementsPDF: (state) => {
      return {
        ...state,
        isPDFDownload: false,
      };
    },
    failureDownloadSettlementsPDF: (state, action) => {
      return { ...state, isPDFDownload: false, isError: action?.payload };
    },

    /////// Send Settlements Email ////////
    requestSendSettlementsEmail: (state) => {
      return { ...state, isEmailSending: true };
    },
    responseSendSettlementsEmail: (state) => {
      return {
        ...state,
        isEmailSending: false,
      };
    },
    failureSendSettlementsEmail: (state, action) => {
      return { ...state, isEmailSending: false, isError: action?.payload };
    },

    /////// Settlement Module download PDF ////////
    requestDownloadSettlementPDF: (state) => {
      return { ...state, isPDFDownload: true };
    },
    responseDownloadSettlementPDF: (state) => {
      return {
        ...state,
        isPDFDownload: false,
      };
    },
    failureDownloadSettlementPDF: (state, action) => {
      return { ...state, isPDFDownload: false, isError: action?.payload };
    },

    /////// Generate Bulk Store ////////
    requestGenerateBulkStore: (state) => {
      return { ...state, isGenerating: true };
    },
    responseGenerateBulkStore: (state) => {
      return {
        ...state,
        isGenerating: false,
      };
    },
    failureGenerateBulkStore: (state, action) => {
      return { ...state, isGenerating: false, isError: action?.payload };
    },
  },
});

export const {
  requestGetSettlements,
  failureGetSettlements,
  responseGetSettlements,
  failureDownloadSettlementsPDF,
  requestDownloadSettlementsPDF,
  responseDownloadSettlementsPDF,
  requestSendSettlementsEmail,
  responseSendSettlementsEmail,
  failureSendSettlementsEmail,
  failureDownloadSettlementPDF,
  requestDownloadSettlementPDF,
  responseDownloadSettlementPDF,
  requestGenerateBulkStore,
  responseGenerateBulkStore,
  failureGenerateBulkStore,
} = SettlementsSlice.actions;
export default SettlementsSlice.reducer;
